import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useValidateEobProcessing() {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.validateEobProcessingDocumentsDocumentKeyEobValidatePostMutation(),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(
        apiClient.getDocumentDocumentsKeyGetOptions({
          path: { key: variables.path.document_key },
        }),
      )
    },
  })
}
